require('./accountsBuyAmazonGiftCardSidebar.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @components
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { ContentBox } = require('commonsComponents/contentBox');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

const AmazonGiftCardDetails = require('components/accounts/accountsBuyAmazonGiftCard/amazonGiftCardDetails/amazonGiftCardDetails');
const AmazonGiftCardImage = require('components/accounts/accountsBuyAmazonGiftCard/amazonGiftCardImage/amazonGiftCardImage');
const AmazonGiftCardReedemptionSteps = require('components/accounts/accountsBuyAmazonGiftCard/amazonGiftCardReedemptionSteps/amazonGiftCardReedemptionSteps');

class AccountsBuyAmazonGiftCardSidebar extends React.Component {

    render(){
        const { immSteps, immAccounts, accountBuyAmazonGiftCard} = this.props;
        return(
            <section className="accounts-buy-amazon-gift-card-sidebar">
                <OKSectionBox className="accounts-buy-amazon-gift-card-sidebar__card-details">
                    <AmazonGiftCardImage
                        immSteps={immSteps}
                        isMedium
                        accountBuyAmazonGiftCard={accountBuyAmazonGiftCard}
                    />
                    <AmazonGiftCardDetails
                        immSteps={immSteps}
                        immAccounts={immAccounts}
                        columnCount={1}
                    />
                </OKSectionBox>
                <div className="accounts-buy-amazon-gift-card-sidebar__reedemption-steps">
                    <AmazonGiftCardReedemptionSteps />
                </div>
                <ContentBox 
                    id="amazon-gift-card-sidebar-content"
                    title={formatText('amazonGiftCard-helpBoxTitle')}
                    smallTitle
                    customClassName="accounts-buy-amazon-gift-card-sidebar-help"
                    footerContent={<div/>}
                >
                    <FormattedText value="amazonGiftCard-helpBoxDescription"/>
                </ContentBox>
            </section>
        );
    }
}

AccountsBuyAmazonGiftCardSidebar.propTypes = {
    accountBuyAmazonGiftCard: PropTypes.object,
    immSteps: PropTypes.object,
    immAccounts: PropTypes.object
}

module.exports = AccountsBuyAmazonGiftCardSidebar;
